// extracted by mini-css-extract-plugin
module.exports = {"list":"Usps_list__S81Sq","item":"Usps_item__x9pNd","icon":"Usps_icon__hFkeE"};